const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M5 4a2.75 2.75 0 0 0-2.75 2.75v11A2.75 2.75 0 0 0 5 20.5h14a2.75 2.75 0 0 0 2.75-2.75v-11A2.75 2.75 0 0 0 19 4zm6.25 1.5V19H5c-.69 0-1.25-.56-1.25-1.25v-11c0-.69.56-1.25 1.25-1.25zM19 19h-6.25V5.5H19c.69 0 1.25.56 1.25 1.25v11c0 .69-.56 1.25-1.25 1.25" clip-rule="evenodd"/></svg>';
export {
  e as w
};
